import { render, staticRenderFns } from "./cn.vue?vue&type=template&id=5be650b2&"
import script from "./cn.vue?vue&type=script&lang=js&"
export * from "./cn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports